export default "__VITE_ASSET__DZhRbJXu__"